module.exports = __webpack_public_path__ + "static/media/100.53c38366.jpg";